import React, { Component } from 'react';
import { connect } from 'react-redux';
import './styles.css';
import { Element, scrollSpy } from 'react-scroll';
import Paper from 'material-ui/Paper';
import Subheader from 'material-ui/Subheader';
import { List, ListItem } from 'material-ui/List'
import RaisedButton from 'material-ui/RaisedButton';
import Photos from './photos';
import SetCardBreadCrumbs from './breadcrumbs';
import Accessories from './../../accessories-kiosk/list';
import Chip from 'material-ui/Chip';
import PrepareOrderFromCard from './card-zones/prepare-order-from-card';
import Question from  './card-zones/question';
import CardContentNavigation from './nav';

class SetCard extends Component {

  constructor() {
    super();
    this.state = { currentPhotoIndex: 0, photoHoverId: '', orderMode: false, orderCreated: false };
  }

  toggleOrderMode = () => {
    this.setState({ orderMode: !this.state.orderMode });
  }
  sendOrder = () => {
    this.setState({ orderCreated: true }, () => {
      this.toggleOrderMode();
    });
  }

  componentDidMount() {
    scrollSpy.update();
  }

  setPhotoHover = photoHoverId => {
    this.setState({ photoHoverId });
  }

  removePhotoHover = () => {
    this.setState({ photoHoverId: ''});
  }

  setCurrentPhotoIndex = currentPhotoIndex => {
    this.setState({ currentPhotoIndex});
  }

  createDescriptionMarkup() {
    const { setsItems, currentSetId } = this.props;
    return {'__html': setsItems[currentSetId].details}
  }

  createTechDataMarkup = () => {
    const { setsItems, currentSetId } = this.props;
    return {'__html': setsItems[currentSetId].techData}
  }

  getAccessoriesJsx = () => {
    return (
      <Accessories for='set' />
    )
  }

  getComplectationJsx = () => {
    const { setsItems, currentSetId } = this.props;
    const complItems = setsItems[currentSetId].complectation || [];
    return (
      <List style={{width: '100%'}}>
        {
          complItems.map( item => {
            return (
              <ListItem
                key={'compl'+item}
                primaryText={item}
              >
              </ListItem>
            );
          })
        }
      </List>
    )
  }

  getDownloadPdfJsx = () => {
    const pdf = 'data:application/octet-stream;base64,' + this.props.presentation;
    const { currentSetId, setsItems } = this.props;
    const set = setsItems[currentSetId];
    const btnLabel = <a href={pdf} download={`${set.title}.pdf`} style={{color: 'rgba(0,0,0,0.87)', textDecoration: 'none'}}>Сохранить в PDF</a>;
    return (
			<div style={{marginRight: '5px'}}>
        <RaisedButton
          label={btnLabel}
        >
        </RaisedButton>
        <RaisedButton
          style={{marginLeft: '1px'}}
          label='Отправить на Email'
        >
        </RaisedButton>
			</div>
		);
	}

  getSetPropertyJsx = text => {
    return (
      <Chip key={text} style={{marginLeft: '8px', marginTop: '8px'}} backgroundColor='#fff' labelColor='#555'>
        {text}
      </Chip>
    )
  }

  getContentJsx = () => {
    const { currentSetId, setsItems } = this.props;
    const set = setsItems[currentSetId];
    const properties = setsItems[currentSetId].properties || [];
    return (
      <div style={{display: 'flex'}} className='setCardInner'>
        <CardContentNavigation set={set} />
        <div className='setCardContent' style={{flex: '1 1 auto', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{display: 'flex', minHeight: '10vh', width: '100%', marginTop: '12px'}}>
            <Element name='compl' style={{width: '95%'}}>
              <Paper style={{padding: '16px', paddingTop: '16px', paddingBottom: '16px', fontSize: '24px', fontWeight: 'bold', color: 'white', background: '#F44336', position: 'relative'}}>
                {set.specialOffer && <div className='ribbon' style={{position: 'absolute', right: '16px', top: '8px', }}></div>}
                {set.specialOffer && <div style={{position: 'absolute', width: '200px', height: '30px', background: '#bbb', right: '-19px', top: '11px', fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #aaa', 'borderTopLeftRadius': '2px', 'borderTopRightRadius': '2px', 'borderBottomLeftRadius': '2px'}}>СПЕЦПРЕДЛОЖЕНИЕ</div>}
                <div>
                  {set.title}
                </div>
                <div style={{display: 'flex', flexWrap: 'wrap', marginLeft: '10px', marginTop: '12px'}}>
                  {properties.map(key => this.getSetPropertyJsx(key))}
                </div>
              </Paper>
            </Element>
          </div>
          {set.details &&
            <div style={{display: 'flex', minHeight: '10vh', width: '100%', marginTop: '12px'}}>
              <Element name='desc' style={{width: '95%'}}>
                <Paper style={{paddingBottom: '30px'}}>
                  <Subheader>
                    Описание
                  </Subheader>
                  <div
                    dangerouslySetInnerHTML={this.createDescriptionMarkup()}
                    style={{display: 'flex', padding: '0px 30px'}}
                    ></div>
                  </Paper>
                </Element>
              </div>
          }
          {set.complectation &&
            <div style={{display: 'flex', minHeight: '10vh', width: '100%', marginTop: '12px'}}>
              <Element name='compl' style={{width: '95%'}}>
                <Paper style={{paddingBottom: '30px'}}>
                  <Subheader>
                    Комплектация
                  </Subheader>
                  <div
                    style={{display: 'flex', padding: '15px 30px'}}
                    >
                      {this.getComplectationJsx()}
                    </div>
                  </Paper>
                </Element>
              </div>
          }
          <div style={{display: 'flex', minHeight: '10vh', width: '100%', marginTop: '12px'}}>
            <Element name='photo' style={{width: '95%'}}>
              <Paper style={{paddingBottom: '30px'}}>
                <Subheader>
                  Фото
                </Subheader>
                <div style={{display: 'flex', justifyContent: 'center'}} >
                  <Photos currentPhotoIndex={this.state.currentPhotoIndex} photoHoverId={this.state.photoHoverId} setPhotoHover={this.setPhotoHover} removePhotoHover={this.removePhotoHover} setCurrentPhotoIndex={this.setCurrentPhotoIndex} />
                </div>
              </Paper>
            </Element>
          </div>
          {set.techData &&
            <div style={{display: 'flex', minHeight: '10vh', width: '100%', marginTop: '12px'}}>
              <Element name='tech' style={{width: '95%'}}>
                <Paper style={{paddingBottom: '30px'}} >
                  <Subheader>
                    Характеристики
                  </Subheader>
                  <div
                    dangerouslySetInnerHTML={this.createTechDataMarkup()}
                    style={{display: 'flex', justifyContent: 'center', padding: '15px 30px'}}
                  ></div>
                </Paper>
              </Element>
            </div>
          }
          {set.accessories &&
            <div style={{display: 'flex', minHeight: '10vh', width: '100%', marginTop: '12px'}}>
              <Element name='access' style={{width: '95%'}}>
                <Paper
                  style={{paddingBottom: '30px', position: 'relative'}}
                >
                  <Subheader>
                    Аксессуары
                  </Subheader>
                  <div
                    style={{display: 'flex', padding: '0px 30px'}}
                  >
                    {this.getAccessoriesJsx()}
                  </div>
                </Paper>
              </Element>
            </div>
          }
        </div>
      </div>
    );
  }

  getSavePresentationJsx() {
    return (
      <div>
        {this.getDownloadPdfJsx()}
      </div>
    );
  }

  render() {
    const { currentSetId, setsItems } = this.props;
    return (
      <div>
        {currentSetId &&
          <div className='setCardContainer' style={{marginBottom: '100vh'}}>
            <div className='setCardLeftNav'>
              <SetCardBreadCrumbs setsCurrent={currentSetId} />
            </div>
            <div className='setCardContent'>
              <div style={{display: 'flex', justifyContent: 'center', marginTop: '12px', marginBottom: '12px'}}>
                {this.getSavePresentationJsx()}
                <PrepareOrderFromCard
                  orderMode={this.state.orderMode}
                  toggleOrderMode={this.toggleOrderMode}
                  orderCreated={this.state.orderCreated}
                  set={setsItems[currentSetId]}
                />
                <Question />
              </div>
              {this.getContentJsx()}
            </div>
          </div>
        }
      </div>
    );
  }

}

export default connect(
  state => {
    return {
      setsItems: state.sets,
      currentSetId : state.ui.set,
      presentation: state.presentations[state.ui.set]
      // accessories: state.accessories //TODO - get only accessories related to the set
    }
  }
)(SetCard);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/set/card/index.js